var _defs, _g, _path, _path2, _g2, _g3, _g4, _g5, _line, _line2, _line3, _line4, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRoadAPhoto(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 361.65,
    height: 478.22,
    viewBox: "0 0 361.65 478.22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1, .cls-2, .cls-4, .cls-5, .cls-6 {\r\n        fill: none;\r\n        stroke: #414042;\r\n        stroke-miterlimit: 10;\r\n      }\r\n\r\n      .cls-1 {\r\n        stroke-width: 5px;\r\n      }\r\n\r\n      .cls-2, .cls-4, .cls-5, .cls-6 {\r\n        stroke-width: 2px;\r\n      }\r\n\r\n      .cls-2 {\r\n        stroke-dasharray: 25;\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: #010101;\r\n      }\r\n\r\n      .cls-5 {\r\n        stroke-dasharray: 23.55 23.55;\r\n      }\r\n\r\n      .cls-6 {\r\n        stroke-dasharray: 21 23.55;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,205l96.5,1.29a28,28,0,0,1,11.87,10c5.51,7.83,7.27,16.78,7.85,20.5q.12,118.29.23,236.59",
    transform: "translate(0.05 0.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,122.64H95.45c2.11-.72,10.09-3.83,15.79-15.2,5.18-10.31,5.29-21.07,5.24-24.47V0",
    transform: "translate(0.05 0.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M360.13,122.64H204c-2.11-.72-10.09-3.83-15.79-15.2C183,97.13,182.93,86.37,183,83V0",
    transform: "translate(0.05 0.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M235.18,205H194.36a26.44,26.44,0,0,0-6.68,8.22c-4.67,8.68-4.77,18.38-4.71,21.6V300.2a312.34,312.34,0,0,1,22.77-52.58A247.64,247.64,0,0,1,235.18,205Z",
    transform: "translate(0.05 0.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M360.13,215.84c-17.33,1.84-57.16,9.69-93.94,52.77-63.87,74.78-63.78,191.54-63.61,207.05",
    transform: "translate(0.05 0.03)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M116.47,470.29",
    transform: "translate(0.05 0.03)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M-72.78,254.34",
    transform: "translate(0.05 0.03)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M172.92,461.48V477.4a.71.71,0,1,0,1.41.17.49.49,0,0,0,0-.17V461.48a.7.7,0,0,0-.7-.7h0a.7.7,0,0,0-.71.69Z",
    transform: "translate(0.05 0.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M173.13,460.84l-6.89,6.89a.71.71,0,0,0,1,1l6.39-6.39,6.39,6.39a.71.71,0,0,0,1,0,.67.67,0,0,0,.2-.48.69.69,0,0,0-.21-.49l-6.89-6.89A.71.71,0,0,0,173.13,460.84Z",
    transform: "translate(0.05 0.03)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M16.66,188.11H.74a.71.71,0,0,1-.17-1.41H16.66a.71.71,0,0,1,.17,1.41Z",
    transform: "translate(0.05 0.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M17.3,187.9l-6.89,6.89a.71.71,0,0,1-1-1l6.39-6.39-6.38-6.34a.7.7,0,0,1,.5-1.2.7.7,0,0,1,.49.2L17.3,187A.72.72,0,0,1,17.3,187.9Z",
    transform: "translate(0.05 0.03)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M344.88,144.11H360.8a.71.71,0,0,0,.17-1.41H344.88a.71.71,0,1,0-.17,1.41Z",
    transform: "translate(0.05 0.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M344.24,143.9l6.89,6.89a.71.71,0,0,0,1-1l-6.39-6.39,6.39-6.38a.7.7,0,0,0-.5-1.2.7.7,0,0,0-.49.2l-6.89,6.89A.71.71,0,0,0,344.24,143.9Z",
    transform: "translate(0.05 0.03)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M128.64,16.62V.7a.71.71,0,0,1,1.41,0V16.62a.71.71,0,0,1-1.41.17A.49.49,0,0,1,128.64,16.62Z",
    transform: "translate(0.05 0.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M128.85,17.26,122,10.38a.71.71,0,0,1,1-1l6.39,6.39,6.38-6.39a.72.72,0,0,1,1,0,.74.74,0,0,1,0,1l-6.89,6.88a.69.69,0,0,1-1,0Z",
    transform: "translate(0.05 0.03)"
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 116.54,
    y1: 90.33,
    x2: 144.14,
    y2: 90.33
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 155.05,
    y1: 239.08,
    x2: 182.64,
    y2: 239.08
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 89.09,
    y1: 177.51,
    x2: 89.09,
    y2: 205.11
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 209.12,
    y1: 122.67,
    x2: 209.12,
    y2: 150.27
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M155,71.44q0-33.6,0-67.18",
    transform: "translate(0.05 0.03)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M154.94,460.64c.06-77.53.06-154.53.05-232",
    transform: "translate(0.05 0.03)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M179.23,324a179.36,179.36,0,0,1,5.91-30.35c4.52-15.76,9.83-26,17.84-41.54,0,0,17.68-34.21,32.74-46.24,3.34-2.67,7-5.14,7-5.14,3.59-2.45,6.81-4.34,9.39-5.75",
    transform: "translate(0.05 0.03)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M.45,163.83c30.42.06,60.63.06,91,0",
    transform: "translate(0.05 0.03)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M355.18,163.8c-46.18.31-91.18.31-137.68.06",
    transform: "translate(0.05 0.03)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoadAPhoto);
export default __webpack_public_path__ + "static/media/road-A-photo.c9d609fc2aa1cc143b6f893897615c18.svg";
export { ForwardRef as ReactComponent };